export abstract class TermsRedirectService {
	public static buildTermsUrl(): string {
		const target = window.location.pathname + window.location.search + window.location.hash;
		if (!target || target === '/') {
			return '/terms';
		}
		return `/terms/${encodeURIComponent(target)}`;
	}
}
